import { MixedContentTypeSearchResult } from '../models/SearchResultTypes';
import { PerformSearchSucceededAction, SearchActionTypes } from './ActionTypes';

export function performSearchSucceeded(results: MixedContentTypeSearchResult): PerformSearchSucceededAction {
  return {
    type: SearchActionTypes.SEARCH_SUCCESS,
    results,
  };
}
